// extracted by mini-css-extract-plugin
module.exports = {"content":"Terminals_content__2xPTP"};